import { Calc } from '@/components/calc/Calc';
import { Footer } from '@/components/Footer/Footer';

import styles from './index.module.scss';

export default function CalcPage() {
	return (
		<div className={styles.root}>
			<Calc />
			<Footer />
		</div>
	);
}
